// extracted by mini-css-extract-plugin
module.exports = {"videoEditor":"AdminVideoEdit_videoEditor__Liq0R","entitySelector":"AdminVideoEdit_entitySelector__xBmxU"};